import { truncateIfTooLong } from 'src/util/truncate';
import { ChipUser } from 'src/components/ChipUser';
import { useAuth } from 'src/contexts/AuthContext';
import { isAdmin } from 'functions/src/types/firestore/User/util';
import { ParticipantAdminDetails } from '../../participants/ParticipantAdminDetails';
import { Member } from 'functions/src/types/firestore/Game/Tournament/Guestlist';

export type TeamMemberDetailsProps = {
  member: Member;
};

// eslint-disable-next-line react-memo/require-memo
export const TeamMemberDetails = ({ member }: TeamMemberDetailsProps) => {
  const { user } = useAuth();
  const { checkedIn, imgUrl, status, tournamentId, ...memberRest } = member;
  const { username, userId } = memberRest;
  return (
    <>
      {!!Object.keys(memberRest).length && (
        <>
          <ChipUser
            username={truncateIfTooLong(username)}
            avatarUrl={imgUrl}
            href={`/profile/${userId}`}
          />
          {isAdmin(user?.email) && !!memberRest && (
            <ParticipantAdminDetails
              {...memberRest}
              sx={{ wordWrap: 'break-word' }}
            />
          )}
        </>
      )}
    </>
  );
};
